export default __webpack_public_path__ + "static/lframe-calculator-518ec6b83cf5b4563fbe28c67b91c28a.png";